export enum StepType {
  Criteria = 'criteria',
  CriteriaV2 = 'criteriaV2',
  CriteriaV3 = 'criteriaV3',
  ProgressStatus = 'progressStatus',
  MultiSelect = 'multiSelect',
  SingleSelect = 'singleSelect',
  GoToAppStep = 'goToAppStep',
  PickASegment = 'pickASegment',
  Reassurance = 'reassurance',
  ProductInformation = 'productInformation',
  PrivacyAgreement = 'privacyAgreement',
  MeetingCommitment = 'meetingCommitment',
  SignUp = 'signUp',
  ContactDetails = 'contactDetails',
  PickAGroup = 'pickAGroup',
  FinishSignUp = 'finishSignUp',
  Payment = 'payment',
  NoDocumentSteps = 'noDocumentSteps',
  ThinkingStep = 'thinkingStep',
  SpecialOfferStep = 'specialOfferStep',
  MockPaymentStep = 'mockPaymentStep',
  SignUpEmail = 'signUpEmail',
  SignUpPhone = 'signUpPhone',
  SinglePagePayment = 'singlePagePayment',
  SinglePagePickAGroup = 'singlePagePickAGroup',
  Age = 'age',
  RoomSuggestions = 'roomSuggestions',
  PickAProduct = 'pickAProduct',
  PickLabels = 'pickLabels',
  SignupWithPayment = 'signupWithPayment',
  ThanksForSharingLoader = 'thanksForSharingLoader',
  SuggestedGuides = 'suggestedGuides',
  GoalsToAchieve = 'goalsToAchieve',
  PauseFullScreen = 'pauseFullScreen',
  EnterEmail = 'enterEmail',
  EnterEmailV2 = 'enterEmailV2',
  EnterEmailV3 = 'enterEmailV3',
  infoV1 = 'infoV1',
  infoV1Ver2 = 'infoV1Ver2',
  infoV2 = 'infoV2',
  infoV2Ver2 = 'infoV2Ver2',
  pickAProgram = 'pickAProgram',
  copingWithNarcissism = 'copingWithNarcissism',
  letsHealTogether = 'letsHealTogether',
}
